import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import CobrancaUsuarioService from 'services/CobrancaUsuarioService';

export const initialState = {
	loading: false,
	loadingPaginado: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	cobrancaUsuariosPaginado: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAllCobrancaUsuario = createAsyncThunk('cobrancaUsuario/all',async () => {
    const response = await CobrancaUsuarioService.all()
    return response;
})

export const getCobrancaUsuarioPaginado = createAsyncThunk('cobrancaUsuario/paginado', async (params, { rejectWithValue }) => {
	try {
		const response = await CobrancaUsuarioService.paginado(params);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar faturas')
	}
})

export const cobrancaUsuarioSlice = createSlice({
	name: 'cobrancaUsuario',
	initialState,
	reducers: {

	},
    extraReducers: (builder) => {
		builder
			.addCase(getAllCobrancaUsuario.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllCobrancaUsuario.fulfilled, (state, action) => {
				state.loading = false
				state.cobrancaUsuarios = action.payload
			})
			.addCase(getAllCobrancaUsuario.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getCobrancaUsuarioPaginado.pending, (state) => {
				state.loadingPaginado = true
			})
			.addCase(getCobrancaUsuarioPaginado.fulfilled, (state, action) => {
				state.loadingPaginado = false
				const payload = action.payload || {}
				state.cobrancaUsuariosPaginado = {
					content: payload.content || [],
					totalElements: payload.totalElements || 0,
					totalPages: payload.totalPages || 0,
					currentPage: payload.number || 0,
					pageSize: payload.size || 10,
				}
			})
			.addCase(getCobrancaUsuarioPaginado.rejected, (state, action) => {
				state.loadingPaginado = false
				state.message = action.payload
				state.showMessage = true
			})
	},
})

export const {
	showLoading,
} = cobrancaUsuarioSlice.actions

export default cobrancaUsuarioSlice.reducer
